// extracted by mini-css-extract-plugin
export default {"headerContainer":"layout-header_headerContainer__Iew88","headerContent":"layout-header_headerContent__FqVe8"};